const ITEMS = [
  "Residential",
  "Pre-Drywall",
  "Warehouse",
  "Office Building",
  "Condo",
  "Multi-Unit",
  "Roof and Drone",
  "Thermal Imaging",
  "Radon",
  "Mold & Environmental",
  "Asbestos & Lead",
  "Sewer Scopes",
  "Pest and Termite",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-ink py-6 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-serif italic text-2xl md:text-4xl text-cream/80 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
